import { css } from '@emotion/react';
import { theme } from '../theme';
import { tokens } from '../tokens';
var ICON_SIZE = '12px';
var variantBackgroundMap = {
    error: theme.white.main,
    info: theme.white.main,
    success: theme.navy.main,
    upgrade: 'transparent',
    warning: theme.navy.main,
};
var wrapperStaticStyle = css({
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    height: tokens.sizing.small,
    justifyContent: 'center',
    position: 'relative',
    width: tokens.sizing.small,
    zIndex: tokens.zIndex.default,
});
export function wrapperStyle(_a) {
    var isCentered = _a.isCentered;
    return [
        wrapperStaticStyle,
        isCentered &&
            css({
                marginLeft: 'auto',
            }),
    ];
}
var iconStaticStyle = css({
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
});
export function iconStyle(_a) {
    var variant = _a.variant;
    return [
        iconStaticStyle,
        css({
            // Obtain the accent color based on the icon variant
            color: variant === 'warning' ? theme[variant].lighter : theme[variant].main,
        }),
    ];
}
export function backgroundStyle(_a) {
    var variant = _a.variant;
    var borderWidth = "".concat(parseInt(ICON_SIZE, 10) / 2, "px");
    // Creative way to get triangle shape for warning
    return variant === 'warning'
        ? css({
            borderBottom: "".concat(ICON_SIZE, " solid ").concat(variantBackgroundMap[variant]),
            borderLeft: "".concat(borderWidth, " solid transparent"),
            borderRight: "".concat(borderWidth, " solid transparent"),
            height: 0,
            width: 0,
        })
        : css({
            backgroundColor: variantBackgroundMap[variant],
            borderRadius: tokens.borderRadius.circle,
            height: ICON_SIZE,
            width: ICON_SIZE,
        });
}
